import React, { Component } from 'react';
import dayjs from 'dayjs';
import services from '@C/Reports/_utils/data';
import {
  formatCurrency,
  TableGrid,
  export2Excel,
  export2PDF,
} from '@C/TableGrid';
import { FuelList } from '@C/Utils';
import DropLoaderLarge from '@C/Utils/DropLoaderLarge';

import './styles.scoped.scss';

const col = [
  {
    name: 'Date',
    key: 'time_stamp',
    sortable: true,
    type: 'date',
  },
  {
    name: 'Product',
    key: 'product',
  },
  {
    name: 'Liters',
    key: 'sold_liters',
  },
  {
    name: 'Testing',
    key: 'testing_liters',
  },
  {
    name: 'Bowser filling',
    key: 'bowser_liters',
  },
  {
    name: 'Sales',
    key: 'sales',
  },
  {
    name: 'Price/Liter',
    key: 'price',
  },
  {
    name: 'Total amount',
    key: 'all',
    type: 'currency',
    formatter(props) {
      return <>{formatCurrency(props.total_amount)}</>;
    },
  },
  //   {
  //     name: 'Testing Liters Returned',
  //     key: 'price',
  //   },
];

class FuelsSalesReport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fuelSalesList: [],
      product_id: '',
      start_date: dayjs().subtract(1, 'month').format('YYYY-MM-DD'),
      end_date: dayjs().format('YYYY-MM-DD'),
      loading: false,
      limit: 20,
      offset: 1,
      count: 0,
    };
    this.limitInput = React.createRef();
  }

  componentDidMount() {
    this.getFuelSales();
  }

  handleDateChange = (e) => {
    const { name, value } = e.target;
    if (name === 'start_date' && dayjs(value).isAfter(this.state.end_date)) {
      this.setState({ [name]: value, end_date: value });
    } else if (
      name === 'end_date' &&
      dayjs(value).isBefore(this.state.start_date)
    ) {
      this.setState({ [name]: value, start_date: value });
    } else {
      this.setState({ [name]: value });
    }
  };

  getFuelSales = () => {
    services
      .getFuelSales(this.state)
      .then((response) => {
        this.setState({
          fuelSalesList: response.data.data.results,
          count: response.data.data.count,
          loading: false,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };
  handleQuickSearch = (e) => {
    if (e.target.value === '' || e.target.value === '0') {
      return;
    }
    this.setState({ limit: e.target.value, offset: 1 }, function () {
      this.getFuelSales();
    });
  };

  handlePagination = (e) => {
    this.setState({ offset: e }, function () {
      this.getFuelSales();
    });
  };
  handleProductChange = (e) => {
    this.setState({ product_id: e.value });
  };
  resetFilter = () => {
    this.setState(
      {
        date: dayjs().format('YYYY-MM-DD'),
        loading: true,
        product_id: '',
        start_date: dayjs().subtract(1, 'month').format('YYYY-MM-DD'),
        end_date: dayjs().format('YYYY-MM-DD'),
      },
      function () {
        this.getFuelSales();
      },
    );
  };

  submitForm = (e) => {
    e.preventDefault();
    this.setState({ loading: true }, function () {
      this.getFuelSales();
    });
  };

  render() {
    const { fuelSalesList } = this.state;
    const exportOptions = {
      fileName: `Fuel Sales - ${this.state.start_date} to ${this.state.end_date}`,
      reportName: 'Fuel Sales Report',
      reportDate: `Date - ${dayjs(this.state.start_date).format('D MMM YY')} to ${dayjs(this.state.end_date).format('D MMM YY')}`,
      reportTotal: `Total amount -  ${
        fuelSalesList
          .reduce((a, b) => a + (b['total_amount'] || 0), 0)
          .toFixed(2) || 0
      }`,
      reportQuantity: `Total liters -  ${
        fuelSalesList
          .reduce((a, b) => a + (b['sold_liters'] || 0), 0)
          .toFixed(2) || 0
      }`,
      reportTesting: `Total testing liters -  ${
        fuelSalesList
          .reduce((a, b) => a + (b['testing_liters'] || 0), 0)
          .toFixed(2) || 0
      }`,
      reportBowser: `Total bowser filling -  ${
        fuelSalesList
          .reduce((a, b) => a + (b['bowser_liters'] || 0), 0)
          .toFixed(2) || 0
      }`,
      reportSales: `Total sales -  ${
        fuelSalesList.reduce((a, b) => a + (b['sales'] || 0), 0).toFixed(2) || 0
      }`,
      reportCustomerName: '',
      reportGst: '',
      reportOpeningBalance: '',
      reportClosingBalance: '',
      reportSaleTotal: '',
      reportTCSTotal: '',
    };
    return (
      <section className="widget full-width list-table inverted">
        <header>
          <div className="stock-info-headers">
            <h3>Fuels Sales Report ({this.state.count})</h3>
            <div className="mini-summary">
              <ul>
                <li>
                  <span>Total liters: </span>
                  <span>
                    {new Intl.NumberFormat('en-IN', {}).format(
                      fuelSalesList.reduce(
                        (a, b) => a + (b['sold_liters'] || 0),
                        0,
                      ) || 0,
                    )}
                  </span>
                </li>
                <li>
                  <span> Total testing liters: </span>
                  <span>
                    {new Intl.NumberFormat('en-IN', {}).format(
                      fuelSalesList.reduce(
                        (a, b) => a + (b['testing_liters'] || 0),
                        0,
                      ) || 0,
                    )}
                  </span>
                </li>
                <li>
                  <span> Total bowser filling: </span>
                  <span>
                    {new Intl.NumberFormat('en-IN', {}).format(
                      fuelSalesList.reduce(
                        (a, b) => a + (b['bowser_liters'] || 0),
                        0,
                      ) || 0,
                    )}
                  </span>
                </li>
                <li>
                  <span> Total sales: </span>
                  <span>
                    {new Intl.NumberFormat('en-IN', {}).format(
                      fuelSalesList.reduce(
                        (a, b) => a + (b['sales'] || 0),
                        0,
                      ) || 0,
                    )}
                  </span>
                </li>
                <li>
                  <span> Total amount: </span>
                  <span>
                    {formatCurrency(
                      fuelSalesList.reduce(
                        (a, b) => a + (b['total_amount'] || 0),
                        0,
                      ) || 0,
                    )}
                  </span>
                </li>
              </ul>
            </div>
          </div>
          <div className="action">
            <button className="submit" type="submit" onClick={this.submitForm}>
              Filter
            </button>
            <button
              onClick={this.resetFilter}
              className="reset-filter"
            ></button>
          </div>
          <div className="export-btns">
            <button
              onClick={() => export2Excel(exportOptions)}
              className={`blue-btn btn-with-icon btn-with-icon__excel action-btn ${this.state.exportingExcel ? 'loading' : ''}`}
              title="Export to Excel"
            >
              Export to Excel
            </button>
            <button
              onClick={() => export2PDF(exportOptions)}
              className={`blue-btn btn-with-icon btn-with-icon__pdf action-btn ${this.state.exportingPdf ? 'loading' : ''}`}
              title="Export to PDF"
            >
              Export to PDF
            </button>
          </div>
        </header>
        <main>
          <div className="table-filters">
            <div className="filter-wrapper">
              <div className="filter-group">
                <label>From date:</label>
                <input
                  className="cstm-date-input"
                  type="date"
                  value={this.state.start_date}
                  name="start_date"
                  onChange={this.handleDateChange}
                />
              </div>
              <div className="filter-group">
                <label>To date:</label>
                <input
                  className="cstm-date-input"
                  type="date"
                  value={this.state.end_date}
                  min={this.state.start_date}
                  onChange={this.handleDateChange}
                  name="end_date"
                />
              </div>
              <div className="filter-group">
                <label> Fuel type:</label>
                <FuelList
                  onChange={this.handleProductChange}
                  value={this.state.product_id}
                />
              </div>
            </div>
          </div>
          <div className="table-wrapper">
            {(() => {
              if (this.state.loading) {
                return <DropLoaderLarge />;
              } else {
                return (
                  <TableGrid
                    col={col}
                    row={fuelSalesList}
                    offset={this.state.offset}
                    count={this.state.count}
                    limit={this.state.limit}
                    handlePagination={this.handlePagination}
                    hideActions={true}
                    enableExport={false}
                    recordsFilter={this.handleQuickSearch}
                    exportOptions={{
                      fileName: `Fuel Sales - ${this.state.start_date} to ${this.state.end_date}`,
                      reportName: 'Fuel Sales Report',
                      reportDate: `Date - ${dayjs(this.state.start_date).format('D MMM YY')} to ${dayjs(this.state.end_date).format('D MMM YY')}`,
                      reportTotal: `Total amount -  ${
                        fuelSalesList
                          .reduce((a, b) => a + (b['total_amount'] || 0), 0)
                          .toFixed(2) || 0
                      }`,
                      reportQuantity: `Total liters -  ${
                        fuelSalesList
                          .reduce((a, b) => a + (b['sold_liters'] || 0), 0)
                          .toFixed(2) || 0
                      }`,
                      reportTesting: `Total testing liters -  ${
                        fuelSalesList
                          .reduce((a, b) => a + (b['testing_liters'] || 0), 0)
                          .toFixed(2) || 0
                      }`,
                      reportBowser: `Total bowser filling -  ${
                        fuelSalesList
                          .reduce((a, b) => a + (b['bowser_liters'] || 0), 0)
                          .toFixed(2) || 0
                      }`,
                      reportSales: `Total sales -  ${
                        fuelSalesList
                          .reduce((a, b) => a + (b['sales'] || 0), 0)
                          .toFixed(2) || 0
                      }`,
                      reportCustomerName: '',
                      reportGst: '',
                      reportOpeningBalance: '',
                      reportClosingBalance: '',
                      reportSaleTotal: '',
                      reportTCSTotal: '',
                    }}
                  />
                );
              }
            })()}
          </div>
        </main>
      </section>
    );
  }
}

export { FuelsSalesReport };
